module.exports = __webpack_public_path__ + "img/ka11.60e3e170.png";